import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import { create } from 'kts-scaffold-framework/utils/form';
import ModulesAction from './Modules.Action';
import {
    Card,
    Button,
    Form,
    Input, 
    Select,
    Icon,
    Divider
} from 'antd';

const css = require('./index.scss');
const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 13 },
};
/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}
@create()
/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    componentWillMount() {
        ModulesAction.getCountry();
        ModulesAction.getProvince('CHN');
    }

    render() {
        const companyInfo = this.modulesState.companyInfo;
        const { form } = this.props; // 获取你的props数据
        const { getFieldDecorator, resetFields, validateFieldsAndScroll } = form;
        return (
            <div className={css['log']}>
                <Card 
                    title={<span className={css.companyMouName}>新增子公司</span>} 
                    bordered={false}
                    extra={
                    <span>
                        <Button
                            onClick={() => ModulesAction.cancel(resetFields)}
                        >取消
                        </Button>
                        <Button
                            onClick={() => ModulesAction.createCompany(validateFieldsAndScroll, resetFields)}
                            type="primary"
                        >保存
                        </Button>
                    </span>
                    }
                >
                <div className={css.formCont}>
                    <Form style={{maxWidth: '770px'}}>
                        <div className={css.sTitle}>
                            <Icon type="info-circle" />
                            <div className={css.notice}>创建公司后，您将是该公司的首个管理员，可以切换至该公司进行管理</div>
                        </div>
                        <FormItem label="公司全称" {...formItemLayout}>
                        {getFieldDecorator('companyName', {
                            rules: [{
                            required: true, message: '公司名称不能为空',
                            },
                            {validator: this.preCheckName}
                            ],
                        })(
                            <Input placeholder="请输入工商注册名称"/>
                        )}
                        </FormItem>
                        <FormItem label="公司纳税人识别号" {...formItemLayout}>
                        {getFieldDecorator('companyTaxId', {
                            rules: [
                                { type: 'string', pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/, required: true, message: '15或17或18或20位大写字母、数字组成', whitespace: true },
                                {validator: this.preCheckTaxId}
                            ],
                        })(
                            <Input placeholder="请输入公司纳税人识别号"/>
                        )}
                        </FormItem>
                        <FormItem label="所在国家或地区" {...formItemLayout}>
                        {getFieldDecorator('country', {
                            initialValue: '中国'
                        })(
                            <Select
                                showSearch={true}
                                placeholder="所在国家或地区"
                                optionFilterProp="children"
                                onSelect={this.changeCountry}
                            >
                                {this.countryList()}
                            </Select>
                        )}
                        </FormItem>
                        {this.modulesState.isChina && (
                        <FormItem label="所在省市" {...formItemLayout}>
                        <div className={css.cityCont}>
                            {getFieldDecorator('state')(
                                <Select
                                    showSearch={true}
                                    placeholder="请选择"
                                    optionFilterProp="children"
                                    className={css.city}
                                    onSelect={this.changeState}
                                >
                                    {this.provinceList()}
                                </Select>
                            )}
                            {getFieldDecorator('city')(
                                <Select
                                    showSearch={true}
                                    placeholder="请选择"
                                    optionFilterProp="children"
                                    className={css.city}
                                >
                                    {this.cityList()}
                                </Select>
                            )}
                        </div>
                        </FormItem>
                        )
                        }
                        <FormItem label="详细地址" {...formItemLayout}>
                        {getFieldDecorator('address', {
                        })(
                            <TextArea rows={4} />
                        )}
                        </FormItem> 
                    </Form> 
                </div>    
                </Card>
                <div className={css.sfooter}>
                    <Divider/>
                    <span className={css.handle}>
                        <Button
                            onClick={() => ModulesAction.cancel(resetFields)}
                        >取消
                        </Button>
                        <Button
                            onClick={() => ModulesAction.createCompany(validateFieldsAndScroll, resetFields)}
                            type="primary"
                        >保存
                        </Button>
                    </span>
                </div>
                
            </div>
        );
    }
    /** 拼接国家列表 */
    private countryList = () => {
        let list = [];
        if (this.modulesState.countryList) {
            this.modulesState.countryList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 拼接省列表 */
    private provinceList = () => {
        let list = [];
        if (this.modulesState.provinceList) {
            this.modulesState.provinceList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 拼接市列表 */
    private cityList = () => {
        let list = [];
        if (this.modulesState.cityList) {
            this.modulesState.cityList.map((item, index) => {
                list.push(<Option value={item.name} key={item.code}>{item.name}</Option>);
            });
        }
        return list;
    }
    /** 国家下拉框改变 */
    private changeCountry = (va, opt) => {
        this.props.form.setFieldsValue({ state: undefined, city: undefined });
        ModulesAction.countryChange(opt.key);
    }
        /** 省下拉框改变 */
        private changeState = (va, opt) => {
        this.props.form.setFieldsValue({ city: undefined });
        ModulesAction.provinceChange(opt.key);
    }
    /** 税号预检测 */
    private preCheckTaxId = async (rule, value, callback) => {  
        const companyTaxId = this.props.form.getFieldValue('companyTaxId');
        const reg = /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
        const companyTaxidMacth = reg.test(companyTaxId);
        if (companyTaxidMacth && companyTaxId && (companyTaxId.length === 15 || companyTaxId.length === 17 || companyTaxId.length === 18 || companyTaxId.length === 20 )) {
            const res = await ModulesAction.preCheck({
                companyTaxId: companyTaxId
            });
            if(res && !res.result) {
                callback(res.message);
            } else {
                callback();
            }
        }
    }
    /** 公司名预检查 */
    private preCheckName = async (rule, value, callback) => {  
        const companyName = this.props.form.getFieldValue('companyName');
        if (companyName) {
            const res = await ModulesAction.preCheck({
                companyName: companyName
            });
            if(res && !res.result) {
                callback(res.message);
            } else {
                callback();
            }
        }   
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/GroupInfo/UI.Log.tsx